const attributes = [
    'balance',
    'amount',
    'merchant_category_code',
    'week_day',
    'month_day',
    'time_now',
    'entry_mode',
    'merchant_id',
    'currency_code',
];

const operators = ['eq', 'neq', 'lt', 'lte', 'gt', 'gte', 'in', 'nin'];

module.exports = { attributes, operators };
